const emailSubscription = async ({ email }) => {
  try {
    const response = await fetch('/api/emailSubscription', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email })
    });
    if (!response.ok) {
      const errorData = await response.json();
      console.warn('errorData', errorData);
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error subscribing:', error);
    throw {
      success: false,
      message: error.message,
      data: error.data
    };
  }
};

export { emailSubscription };
